module.exports = __webpack_public_path__ + "fonts/opensans-bold.2f72cdbd.ttf";